<template>
    <div class="modal">
        <div class="inner">
            <h2>{{ showHeading() }}</h2>
            <div class="content center">
                <div v-html="message"></div>
                <div v-if="loading" class="modal-icon"><font-awesome-icon icon="fa-spinner" class="icon fa-spin" /></div>
                <div v-else class="modal-icon"><font-awesome-icon :icon="showIcon()" class="icon" /></div>
            </div>
            <div class="controls">
                <div :class="['button', 'nav-button', 'spaced', loading ? 'disabled' : 'cancel']" @click="dismissMessage()">Dismiss</div>
                <div v-if="errorStatus == 'delete'" class="button nav-button delete" @click="doAction()">Yes, Delete</div>
            </div>
        </div>
    </div>
</template>
<script>
// https://fontawesome.com/search?p=3&s=regular
export default {
    name: 'message',
    props: {
        section: {
            type: String,
            default: ''
        },
        message: {
            type: String,
            default: ''
        },
        loading: {
            type: [String, Boolean],
            default: false
        },
        errorStatus: {
            type: [String, Boolean],
            default: false
        },
        timeout: {
            type: [String, Number],
            default: 0
        }
    },
	data() {
		return {
			messageTimeout: null
		}
	},
    created() {
        if (this.timeout > 0) {
            this.setMessageTimeout()
        }
    },
    watch: {
		'timeout' () {
            if (this.timeout > 0) {
                this.setMessageTimeout()
            }
		}
	},
	methods: {
        setMessageTimeout() {
            this.messageTimeout = setTimeout(() => { this.dismissMessage() }, 2000)
        },
        dismissMessage() {
            if (!this.loading) {
                clearTimeout(this.messageTimeout)
                this.$emit('dismiss')
            }
        },
        showHeading() {
            if (this.loading) {
                return 'Please Wait'
            }
            switch (this.errorStatus) {
                case 'invalid':
                    return 'Please Correct'
                case 'waiting':
                    return 'Please Wait'
                case 'alert':
                    return 'Alert'
                case 'delete':
                    return 'Confirm'
                case 'error':
                    return 'Oops!'
                default:
                    return 'Success!'
            }
        },
        showIcon() {
            switch (this.errorStatus) {
                case 'invalid':
                    return 'fa fa-ban'
                case 'waiting':
                    return 'fa fa-hourglass'
                case 'alert':
                    return 'fa fa-bell'
                case 'error':
                    return 'fa fa-bug';
                case 'delete':
                    return 'fa fa-trash'
                default:
                    return 'fa fa-check'
            }
        },
        doAction() {
            this.$emit('action')
        }
    }
}
</script>
